// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150350/js/" + chunkId + "." + {"44":"19224289","225":"1435e087","481":"99f59c38","486":"a78c0da3","770":"510e8115"}[chunkId] + ".0.36027362717498423.chunk.js";
};